import Parse, { config } from "../config";

export const Transaction = Parse.Object.extend("Transaction");
export const Contract = Parse.Object.extend("Contract");
export const TransactionType = Parse.Object.extend("TransactionType");
export const InvestmenPlan = Parse.Object.extend("InvestmenPlan");
export const InvestmentType = Parse.Object.extend("InvestmentType");
export const Project = Parse.Object.extend("Project");
